import React from "react";
import { ncbInterpolColors } from "../../../modules/shared/utilities/colorConfig";

interface SubUnit {
  name: string;
  description?: string;
}

interface Unit {
  name: string;
  abbreviation?: string;
  description: string;
  subUnits?: SubUnit[];
}

interface OrganizationStructureProps {
  mainTitle: string;
  mainDescription: string;
  units: Unit[];
}

const OrganizationStructure: React.FC<OrganizationStructureProps> = ({
  mainTitle,
  mainDescription,
  units,
}) => {
  return (
    <div className="p-8">
      <h2
        className={`text-2xl font-bold mb-4 ${ncbInterpolColors.text.primary}`}
      >
        {mainTitle}
      </h2>
      <p className={`${ncbInterpolColors.text.secondary} mb-8`}>
        {mainDescription}
      </p>

      <div className="space-y-6">
        {units.map((unit, index) => (
          <div
            key={index}
            className={`${ncbInterpolColors.background.section} ${ncbInterpolColors.common.roundedSmall} p-6`}
          >
            <div className="mb-4">
              <h3
                className={`text-xl font-bold ${ncbInterpolColors.text.primary}`}
              >
                {unit.name}
                {unit.abbreviation && (
                  <span
                    className={`text-sm font-normal ${ncbInterpolColors.text.tertiary} ml-2`}
                  >
                    ({unit.abbreviation})
                  </span>
                )}
              </h3>
              <p className={`${ncbInterpolColors.text.secondary} mt-2`}>
                {unit.description}
              </p>
            </div>

            {unit.subUnits && unit.subUnits.length > 0 && (
              <div className="mt-4 ml-4">
                <h4
                  className={`text-sm font-semibold ${ncbInterpolColors.text.primary} mb-3`}
                >
                  Unit Kerja:
                </h4>
                <div className="grid gap-x-4 gap-y-3 tablet:grid-cols-2">
                  {unit.subUnits.map((subUnit, subIndex) => (
                    <div key={subIndex} className={`flex items-start gap-x-2`}>
                      <span
                        className={`${ncbInterpolColors.accent.bullet} mt-0.5`}
                      >
                        •
                      </span>
                      <div className="flex-1">
                        <span
                          className={`font-medium ${ncbInterpolColors.text.primary}`}
                        >
                          {subUnit.name}
                        </span>
                        {subUnit.description && (
                          <p
                            className={`text-sm ${ncbInterpolColors.text.secondary} mt-1`}
                          >
                            {subUnit.description}
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrganizationStructure;
